<div class="container-fluid" *ngIf="prescriptionDetails || prescriptionFiles">
  <div class="card mb-4">
    <div class="row align-items-center pt-3">
      <div class="col-lg-6 col-7">
        <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-3">
          <ol class="breadcrumb breadcrumb-links breadcrumb-dark">
            <li class="breadcrumb-item text-primary psp-breadcrumb">
              <a class="text-primary" [routerLink]="'/patients'"> Patients </a>
            </li>
            <li aria-current="page" class="breadcrumb-item active text-gray psp-breadcrumb">
              Patient Profile
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <div class="border-bottom title p-3">
      <h2 class="m-0">Prescription Details</h2>
    </div>

    <div *ngIf="prescriptionSourceType == prescriptionSourceTypeEnum.details" class="prescription-details-container">
      <div class="details-section">
        <div class="brief-info-card">
          <small>{{
            prescriptionDetails?.prescriptionSummary?.creationDate
            | date: "mediumDate"
            }}</small>
          <h2>{{ prescriptionDetails?.prescriptionSummary?.doctorName }}</h2>
          <div class="brief-body">
            <p class="diagnoses-title">Diagnoses</p>
            <ul class="diagnoses-list">
              <li *ngFor="
                  let diagnosis of prescriptionDetails?.prescriptionSummary?.diagnoses">
                {{ diagnosis }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="divider"></div>

      <div class="details-section">
        <h2>Prescriped Medicines</h2>
        <div class="row">
          <div class="col-12">
            <div *ngIf="prescriptionDetails?.prescribedMedicines?.length" class="table-responsive">
              <table class="table align-items-center table-dark table-flush">
                <thead class="thead-dark">
                  <tr>
                    <th>Medicine Name</th>
                    <th>Dosage</th>
                    <th>Frequency</th>
                    <th>Direction</th>
                    <th>Period</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let prescribedMedicine of prescriptionDetails.prescribedMedicines">
                    <tr>
                      <td [appRowspan]="prescribedMedicine.titrations?.length+1" style="direction: ltr;">
                        {{ prescribedMedicine.name }}
                        <span *ngIf="prescribedMedicine.isChronic"
                          class="badge badge-pill badge-danger ml-2">Chronic</span>
                      </td>
                      <td>
                        {{ prescribedMedicine.dosage }}
                        {{ prescribedMedicine.unit }}
                      </td>
                      <td>
                        {{ prescribedMedicine.frequency == 1 ? 'مرة في ال' + prescribedMedicine.frequencyType
                        : prescribedMedicine.frequency == 2 ? 'مرتين في ال' + prescribedMedicine.frequencyType
                        : prescribedMedicine.frequency + ' مرات في ال' + prescribedMedicine.frequencyType }}
                      </td>
                      <td>{{ prescribedMedicine.drugTime }}</td>
                      <td>
                        {{ prescribedMedicine.period }}
                        {{ prescribedMedicine.periodType }}
                      </td>
                    </tr>
                    <tr *ngFor="let titration of prescribedMedicine.titrations; let i = index">
                      <td>
                        {{ titration.dosage }}
                        {{ prescribedMedicine.unit }}
                      </td>
                      <td>
                        {{ titration.frequency == 1 ? 'مرة في ال' + titration.frequencyDuration
                        : titration.frequency == 2 ? 'مرتين في ال' + titration.frequencyDuration
                        : titration.frequency + ' مرات في ال' + titration.frequencyDuration }}
                      </td>
                      <td>{{ titration.direction }}</td>
                      <td>
                        {{ titration.period }}
                        {{ titration.periodDuration }}
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
            <p *ngIf="!prescriptionDetails?.prescribedMedicines?.length">
              There Is No Prescriped Medicines
            </p>
          </div>
        </div>
      </div>

      <div class="divider"></div>

      <div class="details-section">
        <h2>Lab Tests</h2>
        <div class="row">
          <div class="col-12 prop">
            <ul *ngIf="prescriptionDetails?.labTests?.length" class="mb-0">
              <li *ngFor="let labTest of prescriptionDetails.labTests">
                {{ labTest.name }}
              </li>
            </ul>
            <p *ngIf="!prescriptionDetails?.labTests?.length">
              There Is No Lab Tests
            </p>
          </div>
        </div>
      </div>

      <div class="divider"></div>

      <div class="details-section">
        <h2>Radiology</h2>
        <div class="row">
          <div class="col-12 prop">
            <ul *ngIf="prescriptionDetails?.radiology?.length" class="mb-0">
              <li *ngFor="let radiology of prescriptionDetails.radiology">
                {{ radiology.name }}
              </li>
            </ul>
            <p *ngIf="!prescriptionDetails?.radiology?.length">
              There Is No Radiology
            </p>
          </div>
        </div>
      </div>

      <div class="divider"></div>

      <div class="details-section">
        <h2>Physiotherapy</h2>
        <div class="row">
          <div class="col-12 prop">
            <ul *ngIf="prescriptionDetails?.physiotherapy?.length" class="mb-0">
              <li *ngFor="let physioTherapy of prescriptionDetails.physiotherapy">
                {{ physioTherapy.name }}
              </li>
            </ul>
            <p *ngIf="!prescriptionDetails?.physiotherapy?.length">
              There Is No Physiotherapy
            </p>
          </div>
        </div>
      </div>

      <div class="divider"></div>

      <div class="details-section">
        <h2>Additional Notes</h2>
        <div class="row">
          <div class="col-12 prop">
            <div class="notes">
              {{
              prescriptionDetails?.additionalNotes
              ? prescriptionDetails?.additionalNotes
              : "There Is No Additional Notes"
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="prescriptionSourceType == prescriptionSourceTypeEnum.files" class="prescription-files-container">
      <h3 *ngIf="prescriptionFilesAsPDFs?.length">PDFs</h3>
      <div *ngIf="prescriptionFilesAsPDFs?.length" class="files-as-file mb-4">
        <a *ngFor="let prescriptionSrc of prescriptionFilesAsPDFs" (click)="downloadFile(prescriptionSrc)"
          placement="top" tooltip="Click To Download">
          {{ prescriptionSrc.split("/").pop() }}
        </a>
      </div>
      <h3 *ngIf="prescriptionFilesAsImages?.length">Images</h3>
      <div *ngIf="prescriptionFilesAsImages?.length" class="files-as-img">
        <img *ngFor="let prescriptionSrc of prescriptionFilesAsImages" [src]="prescriptionSrc" />
      </div>
    </div>
  </div>
</div>